export let hres78uColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '260',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'typeloan',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '60',
      style: 'min-width: 200px;'
    }, {
      key: 'amtlonreq',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '70',
      class: 'align-right',
      style: 'min-width: 120px;'
    }, {
      key: 'codcurr',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'numlonreq',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 200px;'
    }, {
      key: 'numcont',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'amtlon',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '120',
      class: 'align-right',
      style: 'min-width: 150px;'
    }, {
      key: 'numlon',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '130',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '140',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '150',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '160',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES78UC1',
      labelIndex: '170',
      style: 'min-width: 200px;'
    }
  ]
  let tab3TableColumns = [
    {
      key: 'numcont',
      name: '',
      labelCodapp: 'HRES78UC3',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'dtelonst',
      name: '',
      labelCodapp: 'HRES78UC3',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'amtlon',
      name: '',
      labelCodapp: 'HRES78UC3',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'amtnpfin',
      name: '',
      labelCodapp: 'HRES78UC3',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'dteaccls',
      name: '',
      labelCodapp: 'HRES78UC3',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'desc_codlon',
      name: '',
      labelCodapp: 'HRES78UC3',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'numlon',
      name: '',
      labelCodapp: 'HRES78UC3',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 150px;'
    }
  ]
  let processTableColumns = [
    {
      key: 'periodd',
      name: '',
      labelCodapp: 'HRES78UC7',
      labelIndex: '10',
      class: 'align-center',
      style: 'min-width: 80px;',
      dataType: 'date'
    }, {
      key: 'mthyre',
      name: '',
      labelCodapp: 'HRES78UC7',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 120px;'
    }, {
      key: 'balancd',
      name: '',
      labelCodapp: 'HRES78UC7',
      labelIndex: '30',
      class: 'align-right',
      style: 'min-width: 120px;'
    }, {
      key: 'amtpfind',
      name: '',
      labelCodapp: 'HRES78UC7',
      labelIndex: '40',
      class: 'align-right',
      style: 'min-width: 120px;'
    }, {
      key: 'amtpintd',
      name: '',
      labelCodapp: 'HRES78UC7',
      labelIndex: '50',
      class: 'align-right',
      style: 'min-width: 120px;'
    }, {
      key: 'amtrepmtd',
      name: '',
      labelCodapp: 'HRES78UC7',
      labelIndex: '60',
      class: 'align-right',
      style: 'min-width: 120px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      detailTab3Table: tab3TableColumns,
      columnsProcessTable: processTableColumns
    },
    th: {
      index: indexColumns,
      detailTab3Table: tab3TableColumns,
      columnsProcessTable: processTableColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres78u.js